module.exports = __webpack_public_path__ + "static/media/email.0088ce67.png";